// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__4Q44g","famousSection":"Home_famousSection__IrdhS","premiumSection":"Home_premiumSection__K_i9y","sectionInfoParagraph":"Home_sectionInfoParagraph__d7FCc"};